import api from '@/lib/api';

/**
 * Story strip uses GET /api/posts/feed only so production never spams 405 when
 * GET /api/posts (list_posts) is absent on an older Railway deploy.
 * Client-filters post_type === 'story' (+ optional category).
 *
 * When the backend list route is guaranteed live everywhere, you can optionally
 * add a feature-flagged fast path to GET /api/posts?post_type=story again.
 */
export async function fetchStoryPosts({ limit = 20, category } = {}) {
  const cap = Math.min(Math.max(limit, 1), 50);
  const fetchLimit = Math.min(100, Math.max(cap * 5, 40));

  const res = await api.get('/posts/feed', {
    params: { limit: fetchLimit },
    withCredentials: true,
  });
  const list = Array.isArray(res.data) ? res.data : [];
  let stories = list.filter((p) => p.post_type === 'story');
  if (category && category !== 'all') {
    stories = stories.filter((p) => p.metadata?.category === category);
  }
  return stories.slice(0, cap);
}
